<div class="sticky">
  <div class="top-bar-ribbon container-fluid ">
    <ul class="float-end">
      <li><a href="https://www.india.gov.in/" target="_blank" title="भारत सरकार">भारत सरकार</a><br><a
          href="https://www.india.gov.in/" target="_blank" title="Government of India">Government of
          India</a></li>
      <li><a href="https://www.finmin.nic.in/" target="_blank" title="वित्त मत्रांलय">वित्त मत्रांलय</a><br><a
          href="https://www.finmin.nic.in/" target="_blank" title="Ministry of Finance">Ministry of Finance</a></li>
      <li><a href="https://dor.gov.in/" target="_blank" title="राजस्व विभाग">राजस्व विभाग</a><br><a
          href="https://dor.gov.in/" target="_blank" title="Department of Revenue">Department of Revenue</a></li>

      <li><a href="https://taxinformation.cbic.gov.in/" target="_blank" title="कर सूचना पोर्टल">कर सूचना
          पोर्टल</a><br><a href="https://taxinformation.cbic.gov.in/" target="_blank" title="Tax Information Portal">Tax
          Information Portal</a>
      </li>
      <li> <span class="langauage-font FontWhite" (click)="changeLanguage()">{{currentLanguage}}&nbsp;<br><br></span>
      </li>
      <!--  <li>A &nbsp; A+ &nbsp; A- <br><br></li> -->
      <li><button (click)="changeFont('')" aria-label="normal-size-button" class="font-adjust-button">A</button>&nbsp;
        <button (click)="IncreaseFontSize('+')" aria-label="increase-size-button"
          class="font-adjust-button">A+</button>&nbsp;
        <button (click)="DecreaseFontSize('-')" aria-label="decrease-size-button" class="font-adjust-button">A-</button>
      </li>
      <li><button class="blue-theme-button" (click)="changeColor('bule')"
          aria-label="theme-change-button"></button>&nbsp;
        <button class="purple-theme-button" (click)="changeColor('pur')" aria-label="theme-change-button"></button>
      </li>

    </ul>

  </div>



  <section>
    <div class="container-fluid top-bar float-start noPadding">
      <div class="row">

        <div class="header col-md-12 ">
          <div class="float-start col-m d-7 col-x l-7 logo-branding">
            <div class="float-start logo-img1">
              <a href="#" class="float-start"><img src="content/images/CBIC_logo.png" title="logo of CBIC"
                  class=img-fluid width="107" height="115" /></a>
            </div>
            <div class="float-start branding co l-8 col-s m-8 col-x l-7 " *ngIf="currentLanguage === 'हिन्दी'">
              <h1 cbicTranslate="menu.CBIC"></h1>
              <br>
              <h2 class="float-start" cbicTranslate="menu.SubTitle"></h2>
            </div>

            <div class="float-start branding  co l-8 col-s m-7 col-x l-7 hindi-logo "
              *ngIf="currentLanguage === 'English'">
              <h1 cbicTranslate="menu.CBIC" class="FontBlue"></h1>
              <br>
              <h2 class="float-start" cbicTranslate="menu.SubTitle"></h2>
            </div>

            <div class="float-start c ol-1 co l-xl-3">
              <img src="content/images/satyamevJayate.png" class="img-fluid emblem" title="Indian-emblem" width="57"
                height="96" />
            </div>
          </div>

          <div class="float-end  socail-mediasection col-xl-5 hide-on-small-screen">
            <div class="float-start col-md-12 social-media-link">
              <div class="float-end" style="position: relative;    margin-top: 0.5rem;"  >

                <input class="form-control border-secondary border-right-0 rounded-0" type="search" value="search"
                  id="example-search-input4" style="float: left;
                  width:12vw; margin-top: 2rem;" [(ngModel)]="serachText"  (keyup.enter)="searchResult(serachText)" target="_blank"  />
                <button class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right search-button"
                (click)='searchResult(serachText)'  title="Search" type="button" target="_blank">
                     
                 
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-search FontWhite" viewBox="0 0 16 16">
                    <path
                      d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                
                </button>

                <ul>

                  <!--- <li class="bgNone" *ngFor="let citizens of citizensCornerList" >
                 <cbic-link class="about-des"
                  [linkEn]="citizens.path" [linkHi]="citizens.path" 
                  [linkTextEn]="citizens.titleEn" [linkTextHi]="citizens.titleHi"
                   title="citizen-corner"></cbic-link>
                </li>-->
                <li class="bgNone">
                  <!-- <a href="https://old.cbic.gov.in/htdocs-cbec/about-us" class="about-des" target="_blank" title="about-us-page"> -->
                  <cbic-link class="about-des" [linkEn]="'/entities/cbic-content-mst/MTY5NDM='"
                    [linkHi]="'/entities/cbic-content-mst/MTY5NDM='" title="citizen-charter-page">

                    <span cbicTranslate="menu.CitizenCharter">&nbsp;&nbsp;</span>
                  </cbic-link>

                  <!-- </a> -->
                </li>
                  <li class="bgNone">
                    <!-- <a href="https://old.cbic.gov.in/htdocs-cbec/about-us" class="about-des" target="_blank" title="about-us-page"> -->
                    <cbic-link class="about-des" [linkEn]="'/entities/cbic-content-mst/MTY5NDE='"
                      [linkHi]="'/entities/cbic-content-mst/MTY5NDE='" title="about-us-page">

                      <span cbicTranslate="menu.AboutUs">&nbsp;&nbsp;</span>
                    </cbic-link>

                    <!-- </a> -->
                  </li>

                  <li class="rounded-pill  " *ngFor="let mediaLinks of mediaLinkList">
                    <a href="{{mediaLinks.path}}" target="_blank" title="{{mediaLinks.titleEn}}"><i
                        class="{{mediaLinks.infoEn}}"></i></a>

                  </li>




                </ul>
                <!-- <div class="float-end"><img src="content/images/finance-minister-nirmala.jpg" class="img-fluid FM-pic" title="Finance-Minister-Nirmala Sita-Raman"  /></div> -->
              </div>
            </div>
          </div>
        </div>



      </div>
      <div class="col-md-12 full-width  d-lg-none d-xl-none noPadding d-sm-block  float-start social-media-smallscreen">
        <div class="navbar  noPadd ing">


          <div class=" col-md-12 social-media-link mobile-socail-media">

            <ul class="float-start">
              <!-- <li class="bgNone" >
                <a href="#" class="FontWhite aboout-us-link"  target="_blank" title="Citizen Corner">
                Citizen Corner
              </a>
              </li>-->
              <!-- <li style="display: flex;    height: 38px;">
  <input class="form-control border-secondary border-right-0 rounded-0" type="search" value="search"
                id="example-search-input4" [(ngModel)]="serachText"  (keyup.enter)="searchResult(serachText)" target="_blank"  />
               <button class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right search-button noMargin small-screen-search-btn"
              (click)='searchResult(serachText)'  title="Search" type="button" target="_blank" >
                   
               
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-search FontWhite" viewBox="0 0 16 16">
                  <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              
              </button> 
            </li> -->
            <li class="bgNone">
              <cbic-link class="about-des" [linkEn]="'/entities/cbic-content-mst/MTY5NDM='"
                [linkHi]="'/entities/cbic-content-mst/MTY5NDM='" title="citizen-charter-page">

                <span cbicTranslate="menu.CitizenCharter" class="FontWhite">nbsp;&nbsp;</span>
              </cbic-link>

            </li>
              <li class="bgNone">
                <cbic-link class="about-des" [linkEn]="'/entities/cbic-content-mst/MTY5NDE='"
                  [linkHi]="'/entities/cbic-content-mst/MTY5NDE='" title="about-us-page">

                  <span cbicTranslate="menu.AboutUs" class="FontWhite">nbsp;&nbsp;</span>
                </cbic-link>

              </li>
              <li class="rounded-pill" *ngFor="let mediaLinks of mediaLinkList">
                <a href="{{mediaLinks.path}}" target="_blank"><i class="{{mediaLinks.infoEn}}"></i></a>
              </li>
              <li class="bgNone">
                <span class="langauage-font FontWhite" (click)="changeLanguage()">{{currentLanguage}}</span>
              </li>
              <li><img src="content/images/finance-minister-nirmala.jpg" class="img-fluid FM-pic"
                  title="Finance-Minister-Nirmala Sita-Raman" /></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>




</div>
<!--News Ticker-->
<cbic-newsticker></cbic-newsticker>
